<script lang="ts" setup>
const props = defineProps<{
  title: string;
}>();
</script>

<template>
  <div class="wb-grid-container">
    <span v-if="title" class="owvans-tech-data__title wb-heading-l">{{
      title
    }}</span>
  </div>
</template>

<style lang="scss" scoped></style>
